import { ProjectType } from "@lib/api_ts/projectApi";
import { FieldType } from "../RegistryForm";
import { containsForbiddenChar, isEmptyValue, isYearInRange } from "./validateUtils";

export default function validateField(field: FieldType, value: string | string[] | undefined, projectToSave: Partial<ProjectType> | undefined): string | null {
    // Controlla se il campo è obbligatorio e se il valore è vuoto
    if (isEmptyValue(value) && field.required) {
        return 'Questo campo è obbligatorio.';
    }
    // Controlla se il campo è un array e stoppa la validazione per gli array
    if (Array.isArray(value)) return null;

    // Controlla se il campo è di tipo 'name' e se contiene il carattere "/"
    if (field.name === "name" && containsForbiddenChar(value)) {
        return 'Il nome non può contenere il carattere "/".';
    }

    // Controlla se il campo è di tipo 'date' e stoppa la validazione per i campi che non sono date
    if (field.type !== 'date') return null;
    // Controlla se il campo è vuoto ma non obbligatorio e stoppa la validazione avanzata per i campi che non sono obbligatori

    if (!field.required && !value) return null;

    // Controlla se il campo è di tipo 'date' e se l'anno è compreso tra 2000 e 2100
    if (!isYearInRange(value)) return 'L\'anno deve essere compreso tra il 2000 e il 2100.';


    // controlla se c'è un progetto da salvare e stoppa la validazione se non c'è
    if (!projectToSave) return null;

    // Controlla se il campo 'forcecastStartDate' ha data precedente o uguale al campo 'forecastEndDate'
    if (field.name === 'forecastStartDate' && projectToSave.forecastEndDate) {
        const start = new Date(value);
        const end = new Date(projectToSave.forecastEndDate);
        if (start > end) {
            return 'La data di inizio deve essere precedente o uguale alla data di fine.';
        }
    }

    // Controlla se il campo 'forecastEndDate' ha data precedente o uguale al campo 'forecastStartDate'
    if (field.name === 'forecastEndDate' && projectToSave.forecastStartDate) {
        const start = new Date(projectToSave.forecastStartDate);
        const end = new Date(value);
        if (start > end) {
            return 'La data di fine deve essere successiva o uguale alla data di inizio.';
        }
    }

    // Controlla se il campo 'startDate' ha data precedente o uguale al campo 'endDate'
    if (field.name === "startDate" && projectToSave.endDate) {
        const start = new Date(value);
        const end = new Date(projectToSave.endDate);
        if (start > end) {
            return 'La data di inizio deve essere precedente o uguale alla data di fine.';
        }
    }
    // Controlla se il campo 'endDate' ha data precedente o uguale al campo 'startDate'
    if (field.name === "endDate" && projectToSave.startDate) {
        const start = new Date(projectToSave.startDate);
        const end = new Date(value);
        if (start > end) {
            return 'La data di fine deve essere successiva o uguale alla data di inizio.';
        }
    }

    // Add more validation rules as needed
    return null;
}